import * as React from 'react';

function SvgClockFilled(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={20} height={20} fill="none" viewBox="0 0 20 20" {...props}>
      <path
        fill="#000"
        d="M10.021 20A9.968 9.968 0 010 10.007 9.986 9.986 0 0110.007 0 9.96 9.96 0 0120 9.979C20.014 15.515 15.557 20 10.021 20zM9.011 7.498c0 .827-.013 1.654.015 2.481.014.238.098.519.252.687a153.649 153.649 0 003.378 3.377c.154.155.434.225.659.239a.892.892 0 00.897-.589c.168-.434.07-.827-.253-1.15a248.848 248.848 0 00-2.719-2.718c-.182-.182-.266-.35-.252-.603.014-1.401.014-2.789 0-4.19 0-.631-.42-1.052-1.009-1.038-.547.014-.953.435-.953 1.024-.014.826-.014 1.653-.014 2.48z"
      />
    </svg>
  );
}

export default SvgClockFilled;
